export const urlPattern = /^https?:\/\/([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}(:[0-9]{1,5})?(\/.*)?$/i;
export const urlRegExp = new RegExp(urlPattern);

export default { urlPattern, urlRegExp };
